import { render, staticRenderFns } from "./LabelIntegration.vue?vue&type=template&id=eef47368"
import script from "./LabelIntegration.vue?vue&type=script&lang=js"
export * from "./LabelIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports